import { useState } from 'react';
import { SubmitHandler, useForm } from 'react-hook-form';
import { AdminDemoData } from '@platform/client';
import { FormsInputDropdown } from '@platform/components';
import { AdminFormModal, ModalStage } from '../../AdminFormModal';

type NewDemoEventFormData = {
  isStatic: 'true' | 'false';
};

export const CreateDemoEventModal = (props: { onClose: () => void }) => {
  const [modalStage, setModalStage] = useState<ModalStage>('form');
  const [successText, setSuccessText] = useState<string>();
  const { control, handleSubmit, formState } = useForm<NewDemoEventFormData>({
    mode: 'onChange',
    defaultValues: { isStatic: 'false' },
  });

  const createEventMutator = AdminDemoData.useCreateDemoEvent({
    mutation: {
      onMutate: () => setModalStage('submitting'),
      onError: () => setModalStage('error'),
      onSuccess: (data) => {
        setSuccessText(
          `Event #${data.eventId} ("${data.title}") created, starting ${new Date(
            data.startTime,
          ).toLocaleDateString()}.`,
        );
        setModalStage('success');
      },
    },
  });

  const onSubmit: SubmitHandler<NewDemoEventFormData> = (data) => {
    createEventMutator.mutate({ data: { isStatic: data.isStatic === 'true' } });
  };

  return (
    <AdminFormModal
      title='Create Demo Event'
      onClose={props.onClose}
      modalStage={modalStage}
      successText={successText}
      submitCTA={{
        text: 'Create',
        callback: () => handleSubmit(onSubmit)(),
      }}
    >
      <div className='space-y-2'>
        <p className='text-sm text-gray-600'>
          Creates a realistic community event for the community page.
        </p>
        <FormsInputDropdown
          type='default'
          control={control}
          name='isStatic'
          label='Event type'
          rules={{ required: 'Event type is required' }}
          items={[
            { text: 'One-off event (a few weeks out)', textValue: 'false' },
            { text: 'Static / evergreen (always upcoming)', textValue: 'true' },
          ]}
          error={formState.errors.isStatic}
        />
      </div>
    </AdminFormModal>
  );
};
